import React from "react";
import { Icon, useResponsive } from "@clearabee/ui-library-native";

export const CarbonNeutral = (): React.ReactElement => {
  const { select } = useResponsive();
  const size = select({ base: "xlarge4", small: "xlarge5" });

  return (
    <Icon viewBox="0 0 125 115" size={size}>
      <defs>
        <linearGradient id="a" x1="-.011%" x2="100%" y1="49.926%" y2="49.926%">
          <stop offset="0%" stopColor="#EFF6F6" />
          <stop offset="100%" stopColor="#B6D6EB" />
        </linearGradient>
        <linearGradient id="b" x1="4.09%" x2="96.475%" y1="22.36%" y2="76.491%">
          <stop offset="0%" stopColor="#EFF6F6" />
          <stop offset="100%" stopColor="#B6D6EB" />
        </linearGradient>
        <linearGradient
          id="c"
          x1=".036%"
          x2="99.982%"
          y1="50.046%"
          y2="50.046%"
        >
          <stop offset="0%" stopColor="#EFF6F6" />
          <stop offset="100%" stopColor="#B6D6EB" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          fill="url(#a)"
          d="M.504 10.584c9.576 5.824 17.192 19.264 17.192 30.352 0 5.656-2.016 9.632-5.208 11.48L30.632 42c3.192-1.848 5.208-5.824 5.208-11.48 0-11.088-7.672-24.472-17.192-30.352L.504 10.584z"
          transform="translate(88.274 60.848)"
        />
        <path
          fill="url(#b)"
          d="M0 10.864c1.232.336 2.52.896 3.864 1.68 8.288 4.76 15.064 16.072 15.624 25.76l18.144-10.416c-.56-9.688-7.336-21-15.624-25.76-1.344-.784-2.632-1.344-3.864-1.68L0 10.864z"
          transform="translate(69.288 33.107)"
        />
        <path
          fill="#F0F7F7"
          d="M23.576 19.032L5.432 29.448c2.744-1.568 6.44-1.624 10.472.168L34.048 19.2c-4.032-1.792-7.728-1.736-10.472-.168"
        />
        <path
          fill="url(#c)"
          d="M26.208.392c-2.8 0-5.376.672-7.616 1.96L.448 12.768c5.264-3.024 12.6-2.576 20.664 2.016 10.08 5.768 18.928 16.744 24.192 28.672L63.448 33.04C58.184 21.112 49.336 10.136 39.256 4.368 34.552 1.68 30.128.392 26.208.392z"
          transform="translate(23.95 .49)"
        />
        <path
          fill="#F0F7F7"
          d="M.28 40.906c0-5.656 1.96-9.632 5.208-11.48 2.744-1.568 6.44-1.624 10.472.168.504-8.008 3.64-13.664 8.456-16.408 5.264-3.024 12.6-2.576 20.664 2.016 10.08 5.768 18.928 16.744 24.192 28.672 1.232.336 2.52.896 3.864 1.68 8.288 4.76 15.064 16.072 15.624 25.76 9.576 5.824 17.192 19.264 17.192 30.352 0 5.656-2.016 9.632-5.208 11.48-3.192 1.848-7.672 1.568-12.544-1.232l-70.168-40.32C8.232 65.938.28 52.218.28 40.906"
        />
        <path
          fill="#37C600"
          d="M10.808 36.65c-.504-.28-.952-.336-1.288-.112l5.04-2.912c.336-.168.784-.168 1.288.112l5.096 2.968-5.04 2.912-5.096-2.968zm15.624 3.248l-5.04 2.912c.112-4.872 1.848-8.568 4.928-10.36l5.04-2.912c-3.08 1.792-4.816 5.488-4.928 10.36"
        />
        <path
          fill="#37C600"
          d="M28.784 48.298c-.28-.952-.952-1.848-1.68-2.296l-5.656-3.248 5.04-2.912 5.656 3.248c.728.448 1.4 1.344 1.68 2.296.28.952.112 1.792-.392 2.072l-5.04 2.912c.504-.28.672-1.12.392-2.072m-2.408 11.536c-1.064-1.848-2.856-2.856-3.92-2.24l5.04-2.912c1.064-.616 2.856.392 3.92 2.24 6.552 11.312 17.248 17.472 23.8 13.72l-5.04 2.912c-6.552 3.752-17.248-2.408-23.8-13.72m27.72-15.96c-4.368-7.504-10.08-13.328-15.848-16.632-5.712-3.304-11.48-4.088-15.848-1.568l5.04-2.912c4.368-2.52 10.08-1.736 15.848 1.568 5.712 3.304 11.48 9.128 15.848 16.632 1.064 1.848 1.064 3.864 0 4.48l-5.04 2.912c1.064-.616 1.064-2.632 0-4.48m11.536 19.88l-5.04 2.912c-.168 6.384-2.52 11.312-6.552 13.608l5.04-2.912c4.032-2.296 6.384-7.224 6.552-13.608"
        />
        <path
          fill="#37C600"
          d="M66.752 66.554l-8.176-14.056c-.336-.616-.84-1.12-1.288-1.4-.448-.28-.952-.336-1.288-.112l5.04-2.912c.336-.224.84-.168 1.288.112.448.28.952.728 1.288 1.4l8.176 14.056c.504.896.672 1.904.392 2.52l-5.04 2.912c.336-.616.168-1.624-.392-2.52"
        />
        <path
          fill="#00D400"
          d="M50.176 46.114c-6.552-11.312-17.248-17.472-23.8-13.72-3.136 1.792-4.816 5.488-4.928 10.36l5.656 3.248c.728.448 1.4 1.344 1.68 2.296.28.952.112 1.792-.392 2.072l-8.176 4.704c-.728.392-1.904-.28-2.632-1.512L9.408 39.506c-.504-.896-.672-1.904-.392-2.52.112-.224.224-.336.392-.448.336-.224.784-.168 1.288.112l5.096 2.968c.112-6.496 2.464-11.592 6.552-13.944 4.368-2.52 10.08-1.736 15.848 1.568 5.712 3.304 11.48 9.128 15.848 16.632 1.064 1.848 1.064 3.864 0 4.48-1.008.616-2.8-.392-3.864-2.24m15.288 23.352l-4.816-2.8c-.168 6.384-2.52 11.312-6.552 13.608-8.736 5.04-22.904-3.136-31.64-18.2-1.064-1.848-1.064-3.864 0-4.48 1.064-.616 2.856.392 3.92 2.24 6.552 11.312 17.248 17.472 23.8 13.72 3.024-1.736 4.76-5.32 4.928-10.024l-5.936-3.416c-.728-.448-1.4-1.344-1.68-2.296-.28-.952-.112-1.792.392-2.072l8.176-4.704c.336-.224.84-.168 1.288.112.448.28.952.728 1.288 1.4l8.176 14.056c.504.896.672 1.904.392 2.52a1.037 1.037 0 01-.392.448c-.392.168-.84.168-1.344-.112"
        />
      </g>
    </Icon>
  );
};
